/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Form, Input, Select, Button, Space, Tabs, message,
} from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import JsonEditor from './JsonEditor';

const { TabPane } = Tabs;

const FormContainer = styled.div`
padding: 16px 0;
`;

const KeyValueRow = styled.div`
display: flex;
gap: 8px;
margin-bottom: 8px;
`;

function DictionaryForm({ dictionary, onSubmit, onCancel }) {
  const [form] = Form.useForm();
  const [editMode, setEditMode] = useState('keyvalue');
  const [jsonContent, setJsonContent] = useState({});
  const [keyValuePairs, setKeyValuePairs] = useState([{ key: '', value: '' }]);

  useEffect(() => {
    if (dictionary) {
      form.setFieldsValue({
        name: dictionary.name,
        type: dictionary.type,
        description: dictionary.description || '',
        external_integration_key: dictionary.external_integration_key || '',
      });
      const content = dictionary.content || {};
      setJsonContent(content);
      const pairs = Object.entries(content).map(([key, value]) => ({
        key,
        value: typeof value === 'object' ? JSON.stringify(value) : String(value),
      }));
      setKeyValuePairs(pairs.length > 0 ? pairs : [{ key: '', value: '' }]);
    }
  }, [dictionary, form]);

  const handleModeChange = (mode) => {
    setEditMode(mode);
    if (mode === 'json') {
      const obj = {};
      keyValuePairs.forEach((pair) => {
        if (pair.key) {
          try {
            obj[pair.key] = JSON.parse(pair.value);
          } catch (e) {
            obj[pair.key] = pair.value;
          }
        }
      });
      setJsonContent(obj);
    } else {
      const pairs = Object.entries(jsonContent).map(([key, value]) => ({
        key,
        value: typeof value === 'object' ? JSON.stringify(value) : String(value),
      }));
      setKeyValuePairs(pairs.length > 0 ? pairs : [{ key: '', value: '' }]);
    }
  };

  const addKeyValuePair = () => {
    setKeyValuePairs([...keyValuePairs, { key: '', value: '' }]);
  };

  const removeKeyValuePair = (index) => {
    const newPairs = keyValuePairs.filter((_, i) => i !== index);
    setKeyValuePairs(newPairs.length > 0 ? newPairs : [{ key: '', value: '' }]);
  };

  const updateKeyValuePair = (index, field, value) => {
    const newPairs = [...keyValuePairs];
    newPairs[index][field] = value;
    setKeyValuePairs(newPairs);
  };

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      let content = {};
      if (editMode === 'json') {
        content = jsonContent;
      } else {
        keyValuePairs.forEach((pair) => {
          if (pair.key) {
            try {
              content[pair.key] = JSON.parse(pair.value);
            } catch (e) {
              content[pair.key] = pair.value;
            }
          }
        });
      }
      onSubmit({ ...values, content });
    } catch (error) {
      if (error.message) {
        message.error('Проверьте правильность заполнения формы');
      }
    }
  };

  return (
    <FormContainer>
      <Form form={form} layout="vertical">
        <Form.Item label="Название" name="name" rules={[{ required: true, message: 'Введите название справочника' }]}>
          <Input placeholder="Введите название" />
        </Form.Item>
        <Form.Item label="Тип" name="type" rules={[{ required: true, message: 'Выберите тип справочника' }]}>
          <Select placeholder="Выберите тип">
            <Select.Option value="general">Общий</Select.Option>
            <Select.Option value="operators">Для операторов</Select.Option>
            <Select.Option value="queues">Для очередей</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label="Описание" name="description">
          <Input.TextArea placeholder="Введите описание справочника" rows={3} />
        </Form.Item>
        <Form.Item
          label="Ключ для внешней интеграции"
          name="external_integration_key"
          tooltip="Этот ключ будет использоваться при сохранении в external_data"
          rules={[{ required: true, message: 'Введите ключ для внешней интеграции' }]}
        >
          <Input placeholder="Например: queue_id, operator_id" />
        </Form.Item>
        <Form.Item label="Содержание">
          <Tabs activeKey={editMode} onChange={handleModeChange}>
            <TabPane tab="Ключ-Значение" key="keyvalue">
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                {keyValuePairs.map((pair, index) => (
                  <KeyValueRow key={`pair-${index}`}>
                    <Input placeholder="Ключ" value={pair.key} onChange={(e) => updateKeyValuePair(index, 'key', e.target.value)} style={{ flex: 1 }} />
                    <Input placeholder="Значение" value={pair.value} onChange={(e) => updateKeyValuePair(index, 'value', e.target.value)} style={{ flex: 1 }} />
                    {keyValuePairs.length > 1 && (
                      <Button type="text" danger icon={<MinusCircleOutlined />} onClick={() => removeKeyValuePair(index)} />
                    )}
                  </KeyValueRow>
                ))}
                <Button type="dashed" onClick={addKeyValuePair} icon={<PlusOutlined />} style={{ width: '100%', marginTop: '8px' }}>
                  Добавить поле
                </Button>
              </div>
            </TabPane>
            <TabPane tab="JSON редактор" key="json">
              <JsonEditor value={jsonContent} onChange={setJsonContent} height={450} />
            </TabPane>
          </Tabs>
        </Form.Item>
      </Form>
      <Space style={{ marginTop: '16px', float: 'right' }}>
        <Button onClick={onCancel}>Отмена</Button>
        <Button type="primary" onClick={handleSubmit}>
          {dictionary ? 'Сохранить' : 'Создать'}
        </Button>
      </Space>
    </FormContainer>
  );
}

export default DictionaryForm;
